import React, { Component } from 'react'
import logo from "../utils/images/pp_logo.svg";
import AppBar from "@material-ui/core/AppBar";
import { Container } from "react-bootstrap";
import { Button, Grid, Toolbar } from '@material-ui/core';
import { NavLink } from 'react-router-dom';

class Header extends Component {

    getInTouch = () => {
        window.open('https://www.poolparty.biz/contact');
    }

    render() {
        return (
            <AppBar className="header-bar" style={{ background: '#ffffff' }} position="static" elevation={0} >
                <Grid container>
                    <Grid item xs={3}>
                        <a href="https://www.poolparty.biz/" target="_blank" rel="noopener noreferrer">
                        <img className="header-image" alt="PoolParty Logo" src={logo}></img>
                        </a>
                    </Grid>
                    <Grid item xs={6}>
                        <h3 className="app-title">Entity Recognition Demo</h3>
                    </Grid>
                    <Grid item xs={3}>
                        <Button className="contact-button" onClick={() => this.getInTouch()}>
                            GET IN TOUCH
                </Button>
                    </Grid>
                </Grid>
                <Toolbar variant="dense" style={{ background: '#00adee' }}>
                    <Container className="tab-bar">
                            <NavLink className="tab" exact to="/" activeClassName="selected-tab">Home</NavLink>
                            <NavLink className="tab" exact to="/about" activeClassName="selected-tab">About</NavLink>
                    </Container>
                </Toolbar>
            </AppBar>
        )
    }
}

export default Header;